var React = require('react');

function ParkingIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#256BB3","d":"M13.7,0C18.1,0,22,3,22,7.9s-3.8,7.9-8.3,7.9H10V26H4V0H13.7z M16,8c0-2-1.6-2.9-3.2-2.9H10v5.8h2.9\n\t\tC14.5,10.9,16,10,16,8z"}));
}

ParkingIcon.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 26 26","width":"26","height":"26"};

module.exports = ParkingIcon;

ParkingIcon.default = ParkingIcon;
